module.exports = __webpack_public_path__ + "media/images/form-status-revision-declined-03664652.gif";